var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var noop = function () { };
export var id = function (x) { return x; };
export var range = function (count, start) {
    if (start === void 0) { start = 0; }
    return Array.from(Array(count).keys()).map(function (i) { return start + i; });
};
export var arraysEqual = function (a, b) {
    return a.length === b.length && a.every(function (av, i) { return av === b[i]; });
};
export var shallowEqual = function (a, b) {
    var ka = Object.keys(a);
    var kb = Object.keys(b);
    return ka.length === kb.length && ka.every(function (k) { return a[k] === b[k]; });
};
export function objectFrom(entries) {
    return Array.from(entries).reduce(function (res, _a) {
        var k = _a[0], v = _a[1];
        res[k] = v;
        return res;
    }, {});
}
export function objectMap(src, mapValue, mapKey, mapSymbol) {
    if (mapKey === void 0) { mapKey = id; }
    if (mapSymbol === void 0) { mapSymbol = id; }
    return objectFrom(Object.keys(src)
        .map(function (k) { return [mapKey(k, src[k], src), mapValue(src[k], k, src)]; })
        .concat(Object.getOwnPropertySymbols(src).map(function (k) { return [
        k,
        mapSymbol(src[k], k, src),
    ]; })));
}
export function objectTransform(src, mapEntry) {
    return objectFrom(Object.keys(src)
        .concat(Object.getOwnPropertySymbols(src))
        .map(function (k) { return mapEntry(src[k], k, src); })
        .filter(Boolean));
}
export function getter(t, k, value) {
    if (arguments.length === 2) {
        return { use: function (value) { return getter(t, k, value); } };
    }
    else {
        Object.defineProperty(t, k, { value: value, enumerable: true });
        return value;
    }
}
export function createFactory(c) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // @ts-ignore
        return new (c.bind.apply(c, __spreadArray([void 0], args, false)))();
    };
}
export function createFactoryAs() {
    return function (c) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // @ts-ignore
            return new (c.bind.apply(c, __spreadArray([void 0], args, false)))();
        };
    };
}
export var call = function (fn) { return fn(); };
export var deepReadonly = function (x) { return x; };
var merge2 = function (a, b) { return (__assign(__assign({}, a), (typeof b === "function" ? b(a) : b))); };
export var merge = function (a, b) {
    return b ? merge2(a, b) : function (b) { return merge2(b, a); };
};
var mergeDeepRec = function (a, b) {
    if (!isPlainObject(a) || !isPlainObject(b))
        return b;
    var res = __assign(__assign({}, a), b); // copy symbols
    for (var k in b) {
        res[k] = mergeDeepRec(a[k], b[k]);
    }
    return res;
};
var mergeDeep2 = function (a, b) {
    return mergeDeepRec(a, typeof b === "function" ? b(a) : b);
};
export var mergeDeep = function (a, b) {
    return b ? mergeDeep2(a, b) : function (b) { return mergeDeep2(b, a); };
};
export var join = function (a, sep, b) { return (a + sep + b); };
export var namespace = function (s) {
    return function (suffix) {
        return join(s, "/", suffix);
    };
};
export function assert(condition, msg) {
    if (msg === void 0) { msg = "Assertion failed"; }
    if (!condition)
        throw new Error(msg);
}
export var isPlainObject = function (x) {
    return !!x && typeof x === "object" && Object.getPrototypeOf(x) === Object.prototype;
};
export function flatMap(src, fn) {
    var res = [];
    src.forEach(function (x, i) { return res.push.apply(res, fn(x, i)); });
    return res;
}
export function diff(a, b, _a) {
    var _b = _a.getId, getId = _b === void 0 ? id : _b, enter = _a.enter, exit = _a.exit, update = _a.update;
    var ma = enter ? new Map(a.map(function (x, i) { return [getId(x), i]; })) : undefined;
    var mb = exit || update ? new Map(b.map(function (x, i) { return [getId(x), i]; })) : undefined;
    mb &&
        a.forEach(function (x, i) {
            var bi = mb.get(getId(x));
            if (bi === undefined) {
                exit === null || exit === void 0 ? void 0 : exit(x, i);
            }
            else if (i !== bi) {
                update === null || update === void 0 ? void 0 : update(x, bi, i);
            }
        });
    ma &&
        b.forEach(function (x, i) {
            var ai = ma.get(getId(x));
            if (ai === undefined) {
                enter === null || enter === void 0 ? void 0 : enter(x, i);
            }
        });
}
export function overwrite(x, fn) {
    var snapshot = Object.defineProperties({}, Object.getOwnPropertyDescriptors(x));
    var newProps = Object.getOwnPropertyDescriptors(fn(snapshot));
    return Object.defineProperties(x, newProps);
}
export function memoize(fn) {
    var prevArgs;
    var prevResult;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prevArgs && arraysEqual(prevArgs, args)) {
            return prevResult;
        }
        prevArgs = undefined; // in case of exception
        prevResult = fn.apply(void 0, args);
        prevArgs = args;
        return prevResult;
    };
}
